<template>
  <div
    v-if="isValid()"
    class="c-map-label-car"
    :style="`font-size: ${font_size}px`"
  >
    <ul>
      <li><b>{{ item.number }}</b> / {{ classTime.toMin(item.timeToPreviousVehicle, '') }}</li>
    </ul>
  </div>
</template>

<script>
import { ClassTime } from '@/helpers/base'
export default {
  name: 'c-map-label-car',
  props: {
    item: {
      type: Object,
      default() {
        return {}
      }
    },
    font_size: {
      type: [String, Number],
      default: 12
    },
  },
  data() {
    return {
      classTime: new ClassTime()
    }
  },
  methods: {
    /* Хэлперы */
    isValid() {
      return Object.keys(this.item).length != 0
    }
    /* Хэлперы END */
  }
}
</script>

<style lang="scss">
  .c-map-label-car {
    position: absolute;
    display: inline-block;
    padding: 4px 8px !important;
    list-style: none;
    width: auto;
    top: 1px;
    left: 42px;
    font-size: 12px;
    background: rgba(255, 255, 255, 0.5);
    text-shadow: 0 0 1px #fff;
    border-radius: 10px;
    z-index: 10;
    box-shadow: 0px 1px 5px rgba(82, 82, 82, 0.3);
    transition: all 1s ease-out;
    b {
      font-weight: 600;
    }
    ul {
      list-style: none;
      padding: 0 !important;
      text-align: left;
      font-size: inherit;
    }
    li {
      padding: 0 5px;
      white-space: nowrap;
      font-size: inherit;
    }
  }
</style>